import React, {useEffect} from 'react';
import {VStack} from "native-base";
import AppText from "../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../styles/GlobalStyles";
import {t} from "../../../../../../services/i18n";
import SimpleInput from "../../../../../common/SimpleInput";
import {Colors} from "../../../../../../styles/Colors";
import {checkRequired} from "../../../../../../services/stepperService";
import MessageTextFormInput from "../../../../../common/MessageTextFormInput";
import TextEditor from "../../../../../common/TextEditor/TextEditor";
import {isMobile} from "../../../../../../services/Helpers";

const NoteTemplate = (props) => {
    const { values, errors, setFieldValue, touched, validationObject } = props;
    useEffect(() => {
        console.log('values',values)
    }, [values]);
    return (
        <VStack space={'1rem'} flex={1}>
            <VStack space={'0.2rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('note-name')}{checkRequired('name', validationObject)}</AppText>
                <SimpleInput value={values.name}
                             onChangeCallback={(val) => setFieldValue('name', val)}
                             error={(touched.name && errors.name) || null}
                             width={'100%'}
                             maxLength={40}
                             showCount
                             placeholder={t('note-name-placeholder')}
                />
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error}>{touched.name && errors.name ? errors.name : null}</AppText>
            </VStack>
            <VStack space={'0.2rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('noteText')}{checkRequired('content', validationObject)}</AppText>
                <div style={{height: '450px'}}>
                    <TextEditor placeholder={t(`note-editor-placeholder${isMobile ? '-mobile' : ''}`)}
                                onChange={(text) => setFieldValue('content', text)}
                                value={values.content}
                                allowTable={true}
                    />
                </div>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error}>{touched.content && errors.content ? errors.content : null}</AppText>
            </VStack>

        </VStack>
    );
};

export default NoteTemplate;